import { render, staticRenderFns } from "./FilterNews.vue?vue&type=template&id=40edc9a9&"
import script from "./FilterNews.vue?vue&type=script&lang=js&"
export * from "./FilterNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports